import { motion } from "framer-motion";

const STEPS = [
  { n: "01", t: "Business Assessment", d: "Diagnose the current state — people, process, and performance." },
  { n: "02", t: "Process Mapping", d: "Document current and future-state workflows visually." },
  { n: "03", t: "Gap Identification", d: "Pinpoint where reality fails to meet target operating standards." },
  { n: "04", t: "Bottleneck Analysis", d: "Quantify the cost of every delay and constraint." },
  { n: "05", t: "Improvement Recommendations", d: "Prioritize initiatives by ROI, effort, and risk." },
  { n: "06", t: "SOP Development", d: "Codify the right way to work — scalable and auditable." },
  { n: "07", t: "KPI Implementation", d: "Wire the dashboard. Make performance visible at every level." },
  { n: "08", t: "Change Management", d: "Move people through the change curve with confidence." },
  { n: "09", t: "Performance Monitoring", d: "Operate the new process with weekly governance rhythms." },
  { n: "10", t: "Continuous Improvement", d: "Sustain gains and unlock the next wave of value." },
];

export default function Methodology() {
  return (
    <section id="methodology" className="bg-[#0A2540] text-white relative overflow-hidden">
      <div className="absolute inset-0 hero-grid opacity-[0.07]" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 relative">
        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-6">
            <div className="inline-flex items-center gap-2 text-[10px] font-bold tracking-[0.25em] uppercase text-[#10B981] mb-5">
              <span className="h-px w-8 bg-[#10B981]" /> The Framework
            </div>
            <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              Our proven process improvement framework
            </h2>
          </div>
          <div className="md:col-span-6 flex md:items-end">
            <p className="text-white/70 leading-relaxed">
              Ten disciplined steps that turn ambition into results. Battle-tested across manufacturing,
              healthcare, logistics, and professional services.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-px bg-white/10">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.4, delay: (i % 5) * 0.05 }}
              className="bg-[#0A2540] p-6 hover:bg-[#061A30] transition-colors duration-300 group relative"
            >
              <div className="flex items-baseline justify-between mb-4">
                <span className="font-display font-bold text-3xl text-[#10B981] tabular">{s.n}</span>
                <div className="h-px flex-1 ml-3 bg-white/10 group-hover:bg-[#10B981]/40 transition-colors" />
              </div>
              <h3 className="font-display font-semibold text-lg text-white mb-2 leading-snug">{s.t}</h3>
              <p className="text-xs text-white/60 leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
